<template>
  <div class="our clearfix">
      <div class="our_list clearfix">
        <div class="our_item">
          <router-link to="/m/our/aboutUs">
            <div class="our_item_img">
              <i class="icons i1"></i>
            </div>
            <p class="our_text">关于帝景</p>
            <p>ABOUT US</p>
          </router-link>
        </div>
        <div class="our_item">
          <router-link to="/m/our/core">
            <div class="our_item_img">
              <i class="icons i2"></i>
            </div>
            <p class="our_text">核心价值</p>
            <p>CORE VALUE</p>
          </router-link>
        </div>
        <div class="our_item">
          <router-link to="/m/our/news">
            <div class="our_item_img">
              <i class="icons i3"></i>
            </div>
            <p class="our_text">新闻</p>
            <p>NEWS</p>
          </router-link>
        </div>
        <div class="our_item">
          <router-link to="/m/our/cases/15">
            <div class="our_item_img">
              <i class="icons i4"></i>
            </div>
            <p class="our_text">客户案例</p>
            <p>CUSTORME CASE</p>
          </router-link>
        </div>
        <div class="our_item">
          <router-link to="/m/our/brand/11">
            <div class="our_item_img">
              <i class="icons i5"></i>
            </div>
            <p class="our_text">品牌精选</p>
            <p>BRAND SELECTION</p>
          </router-link>
        </div>
        <div class="our_item">
          <router-link to="/m/our/contact">
            <div class="our_item_img">
              <i class="icons i6"></i>
            </div>
            <p class="our_text">联系我们</p>
            <p>CONTACT US</p>
          </router-link>
        </div>
        <div class="our_item sp">
          
            <i class="icons i7"></i>
     
          
        </div>
        <div class="our_item sp">
      
            <i class="icons i8"></i>
  
          
        </div>
      </div>
  </div>
</template>

<script>
/*import Swiper from 'Swiper'
import swipercss from '../../../node_modules/_swiper@3.4.2@swiper/dist/css/swiper.min.css'*/
export default {
  name: 'app',
  data(){
    return{
      cremq:false,
      cpcs:true
    }
  },
  watch:{
    '$route':function(to,from){
      //this.getconfig()
    }
  },
  mounted:function(){

  }
}
</script>

<style scoped>
 .our{
  padding: 0.2rem;
  background-color: 
 }
 .our_item{
  width: 2.9rem;
  float: left;
  margin-right: 0.2rem;
  height: 3.2rem;
  border-radius: 0.04rem;
  background-color: #f8f7f7;
  margin-bottom: 0.2rem;
  text-align: center;
 }
 .our_item.sp{
  height: 1.2rem;
  position: relative;
 }
 .our_item:nth-child(2n){
  margin-right: 0;
  
 }
 .our_item p{
  font-size: 0.24rem;
  color: #5d5d5d;
 }
 .our_item_img{
  height: 1.4rem;
  position: relative;
  margin-top: 0.4rem;
 }
 .our_item i{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
 }
 .icons{
  display: inline-block;
  background-image: url('/static/images/m/our_icons.png');
  background-size: 3.08rem 1.94rem;
 }

 .i1{
   width: 0.55rem; height: 0.59rem;
   background-position:-0.97rem -0.61rem;
 }
 .i2{
  width: 0.67rem; height: 0.64rem;
  background-position: -0.1rem -0.61rem;
 }
 .i3{
   width: 0.48rem; height: 0.40rem;
   background-position: -2.5rem -0.1rem;
 }
 .i4{
  width: 0.44rem; height: 0.47rem;
  background-position: -1.72rem -0.61rem;
 }
 .i5{
  width: 0.39rem; height: 0.45rem;
    background-position: -2.5rem -0.7rem;
 }
 .i6{
  width: 0.39rem; height: 0.43rem;
    background-position: -2.5rem -1.35rem;
 }
 .i7{
   width: 0.76rem; height: 0.39rem;
    background-position: -0.1rem -1.45rem;
 }
 .i8{
  width: 2.20rem; height: 0.31rem;
  background-position: -0.1rem -0.1rem;
 }
</style>


// WEBPACK FOOTER //
// src/components/mobile/our.vue